import React from "react";

import { ClassNames } from "./StyleRegistry";
import { useStyles } from "./StyleProvider";
import { useWindowSize } from "../../system";
import { useTheme } from "../theme";
import { getDynamicClassStyle } from "./lib";

export function useClassNames(classNames: ClassNames = []) {
  const { theme } = useTheme();
  const size = useWindowSize();
  const classGroups = useStyles();
  const style = React.useMemo(() => {
    let styles = {};
    classNames.forEach((clsName) => {
      if (!clsName) return;
      let cls = classGroups[clsName];
      if (!cls) {
        cls = getDynamicClassStyle(clsName);
        if (!cls) {
          console.warn(`Class '${clsName}' not found.`);
          return;
        }
      }
      if (typeof cls == "function") {
        cls = cls(theme);
      }
      styles = { ...styles, ...cls };
    });
    return styles;
  }, [theme, size, classNames]);
  return style as any;
}
